<template>
  <v-tooltip
    :max-width="maxWidth"
    v-bind="$attrs"
    :color="color"
    :open-delay="openDelay"
    :nudge-right="nudgeRight"
    :z-index="zIndex"
  >
    <template #activator="{on, value}">
      <slot name="activator" :on="on" :value="value" />
    </template>
    <span class="px-1 pre-line" :class="`text-${text}`" v-html="$t(message)" />
  </v-tooltip>
</template>
<script>
export default {
  name: 'TooltipEffect',
  inheritAttrs: false,
  props: {
    message: {
      type: [String, Number],
      default: '',
    },
    color: {
      type: String,
      default: 'activeLink',
    },
    openDelay: {
      type: [String, Number],
      default: 100,
    },
    nudgeRight: {
      type: [String, Number],
      default: 0,
    },
    zIndex: {
      type: [String, Number],
      default: 2000,
    },
    text: {
      type: String,
      default: 'lowercase',
    },
    maxWidth: {
      type: String,
      default: '800',
    },
  },
}
</script>
